import { BiDetail } from 'react-icons/bi';
import styled from 'styled-components';
import colors from '../../styles/colors';

interface TableColumnProps {
  width: string;
}

export const TableLine = styled.tr`
  width: 100%;
  display: flex;
  padding: 0 1rem;
`;

export const TableColumn = styled.td<TableColumnProps>`
  border-bottom: 1px dashed ${colors.primary};
  padding: 0.6rem 5px;
  width: ${props => props.width};
  display: flex;
  align-items: center;

  button {
    padding: 3px 5px;
    border: 0;
    border-radius: 0.5rem;
    background-color: ${colors.aux1};
    color: #fff;
    text-align: center;
    display: block;
    transition: filter 0.2s;

    &:hover {
      filter: drop-shadow(0 0 0.25rem rgba(0, 0, 0, 0.5));
    }
  }
`;

export const DetailsIcon = styled(BiDetail)`
  justify-content: center;
  height: 20px;
  width: 20px;
`;
